import React, { ChangeEvent } from 'react'
import { Grid, InputLabel } from "@mui/material"
import AddIcon from '@mui/icons-material/Add';

type ButtonPropsType = {
  onClickButton: (event: ChangeEvent<HTMLInputElement>) => void
  text: string
}

export const ButtonAddAttachment = (props: ButtonPropsType) => {
  return (
    <Grid item >
      <InputLabel htmlFor="fileInput" style={{ backgroundColor: '#00a0d1', padding: '4px' }}>
        <AddIcon style={{ color: 'white', verticalAlign: 'text-bottom' }} fontSize='small' id='icon' />
        <span style={{ color: 'white', cursor: 'pointer', backgroundColor: '#00a0d1', paddingRight: '4px' }}>{props.text}</span>
      </InputLabel>
      <input
        id='fileInput'
        type="file"
        name="myImage"
        onChange={props.onClickButton} />
    </Grid>
  )
}
